import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';
import PropTypes from 'prop-types';

import {Form, InputNumber, message, Modal} from 'antd';

import {createVital} from 'services/PatientService';
import {VitalType} from 'shared/constants/AppConst';
import {handleError} from 'utils/MessageUtils';

export const Editor = (props) => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();
  const [form] = Form.useForm();
  const {patientId, vital, setVital, editing, setEditing} = props;

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const onCancel = () => {
    setEditing(false);
  };

  const onSave = () => {
    form.validateFields().then((values) => {
      createVital(headers, patientId, {
        type: VitalType.RESP_RATE,
        value: values.value,
      })
        .then((res) => {
          setVital(res.data);
          setEditing(false);
        })
        .catch((error) => handleError(message, error));
    });
  };

  return (
    <Modal
      title={intl.messages['patient.respRate']}
      centered
      visible={editing}
      okText={intl.messages['common.save']}
      onCancel={() => onCancel()}
      onOk={() => onSave()}
      destroyOnClose={true}>
      <Form form={form} layout='vertical' initialValues={vital}>
        <Form.Item
          name='value'
          label={`${intl.messages['common.value']} (brpm)`}
          rules={[
            {
              required: true,
              message: `${intl.messages['common.value']} ${intl.messages['validation.required']}`,
            },
          ]}>
          <InputNumber
            addonAfter='brpm'
            step={1}
            max={200}
            style={{width: '100%'}}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

Editor.propTypes = {
  patientId: PropTypes.string,
  vital: PropTypes.object,
  setVital: PropTypes.func,
  editing: PropTypes.bool,
  setEditing: PropTypes.func,
};
